module.exports = __webpack_public_path__ + "static/img/030_TO8_1486.777eb2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/030_TO8_1486.jpg
// module id = AgWy
// module chunks = 0